define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.capitalize = void 0;
    function capitalize(value) {
        if (!value) {
            return;
        }
        var valueStr = value.toString();
        return "".concat(valueStr.charAt(0).toUpperCase()).concat(value.slice(1));
    }
    exports.capitalize = capitalize;
});
//# sourceMappingURL=PluginsCustomFilter.js.map